var DeckGroupBackgroundColor;
(function (DeckGroupBackgroundColor) {
    DeckGroupBackgroundColor["DEFAULT"] = "default";
    DeckGroupBackgroundColor["TRANSPARENT"] = "transparent";
    DeckGroupBackgroundColor["WHITE"] = "white";
})(DeckGroupBackgroundColor || (DeckGroupBackgroundColor = {}));
export { DeckGroupBackgroundColor, };
//# sourceMappingURL=deck-constants.js.map